import withAuthHeader from '../../utils/withAuthHeader';
import checkAuthorizationError from '../../utils/checkAuthorizationError';
import {
  mapDestaqueFormToApi,
  mapFetchDestaqueIdResponse,
  mapFetchDestaquesResponse
} from '../mappers/destaques';

export const fetchDestaques = () => async (dispatch, getState, api) => {
  let result = {};
  try {
    const url = `api/v1/dashboard/destaques`;
    const apiResponse = await api.get(url, {
      ...withAuthHeader()
    });

    const response = mapFetchDestaquesResponse(apiResponse.data);
    result = {
      success: true,
      data: response
    };
  } catch (e) {
    checkAuthorizationError(e, dispatch);
    result = {
      error: e.response ? `Erro ${e.response.status}: ${e.message}` : e.message
    };
  }
  return result;
};

export const fetchDestaqueId = (destaqueId) => async (dispatch, getState, api) => {
  let result = {};
  try {
    const url = `api/v1/dashboard/destaques/${destaqueId}`;
    const apiResponse = await api.get(url, {
      ...withAuthHeader()
    });

    const response = mapFetchDestaqueIdResponse(apiResponse.data);
    result = {
      success: true,
      data: response
    };
  } catch (e) {
    checkAuthorizationError(e, dispatch);
    result = {
      error: e.response ? `Erro ${e.response.status}: ${e.message}` : e.message
    };
  }
  return result;
};

export const postDestaque = (formData) => async (dispatch, getState, api) => {
  let result = {};
  try {
    const url = `api/v1/dashboard/destaques`;
    const data = mapDestaqueFormToApi(formData);
    await api({
      method: 'POST',
      url,
      data,
      headers: {
        'Content-Type': 'multipart/form-data',
        ...withAuthHeader(false)
      }
    });
    result = {
      success: true
    };
  } catch (e) {
    checkAuthorizationError(e, dispatch);
    result = {
      error: e.response ? `Erro ${e.response.status}: ${e.message}` : e.message
    };
  }
  return result;
};

export const updateDestaque = (destaqueId, formData) => async (dispatch, getState, api) => {
  let result = {};
  try {
    const url = `api/v1/dashboard/destaques/${destaqueId}`;
    const data = mapDestaqueFormToApi(formData);
    await api({
      method: 'POST',
      url,
      data,
      headers: {
        'Content-Type': 'multipart/form-data',
        ...withAuthHeader(false)
      }
    });
    result = {
      success: true
    };
  } catch (e) {
    checkAuthorizationError(e, dispatch);
    result = {
      error: e.response ? `Erro ${e.response.status}: ${e.message}` : e.message
    };
  }
  return result;
};

export const statusDestaque = (destaqueId) => async (dispatch, getState, api) => {
  let result = {};
  try {
    const url = `api/v1/dashboard/destaques/${destaqueId}`;
    const apiResponse = await api.put(url, '', {
      ...withAuthHeader()
    });

    result = {
      success: true,
      data: apiResponse.data
    };
  } catch (e) {
    checkAuthorizationError(e, dispatch);
    result = {
      error: e.response ? `Erro ${e.response.status}: ${e.message}` : e.message
    };
  }
  return result;
};

export const removeDestaque = (destaqueId) => async (dispatch, getState, api) => {
  let result = {};
  try {
    const url = `api/v1/dashboard/destaques/${destaqueId}`;
    const apiResponse = await api.delete(url, {
      ...withAuthHeader()
    });

    result = {
      success: true,
      data: apiResponse.data
    };
  } catch (e) {
    checkAuthorizationError(e, dispatch);
    result = {
      error: e.response ? `Erro ${e.response.status}: ${e.message}` : e.message
    };
  }
  return result;
};
